import { render, staticRenderFns } from "./DeletePost.vue?vue&type=template&id=597022b2&scoped=true&"
import script from "./DeletePost.vue?vue&type=script&lang=js&"
export * from "./DeletePost.vue?vue&type=script&lang=js&"
import style0 from "./DeletePost.vue?vue&type=style&index=0&id=597022b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597022b2",
  null
  
)

export default component.exports